// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__11d2E","col":"styles_col__29-kc"};